(function () {
    'use strict';

    angular
        .module('notificationsPlatform')
        .controller('NotificationsGeneralFormController', NotificationsGeneralFormController)

    NotificationsGeneralFormController.$inject = ['$uibModal', 'NotificationsPlatformService', '$uibModalInstance', 'toastr', 'notification'];


    function NotificationsGeneralFormController($uibModal, NotificationsPlatformService, $uibModalInstance, toastr, notification) {
        var vm = this;

        const notificationDefault = {
            target: 'all',
            language: 'en',
            when: 'start',
            content: ''
        }
        vm.notification = notification ? notification : notificationDefault

        vm.ok   = saveGeneralNotification
        vm.cancel = hideModal
        vm.targetOptions = [
            {id: 'all', name: 'All'},
            {id: 'visitor', name: 'For students'},
            {id: 'representativeExhibitor', name: 'For exhibitors'},
        ];
        vm.languageOptions = [
            {id: 'en', name: 'English'},
            {id: 'pt', name: 'Portuguese'},
            {id: 'es', name: 'Spanish'},
            {id: 'tr', name: 'Turkish'},
        ];
        vm.whenOptions = [
            {id: 'start', name: 'Start'},
            {id: 'during', name: 'During'},
            {id: 'near-and-at-end', name: 'Near and at end'},
            {id: 'there-talks', name: 'If there area talks'},
        ]

        vm.ckeditorOptions = {
            language: "en",
            allowedContent: true,
            entities: false,
            linkShowTargetTab: false,
            toolbar: [
                [ 'Link' ]
            ]
        };

        function activate() {
            removeLinkOptions()
        }

        function saveGeneralNotification (){
            console.log('Saving general notification')
            console.log(vm.notification)
            if(vm.notification.id){
                vm.notification.language = vm.notification.language.id
                vm.notification.when = vm.notification.when.id
            }
            NotificationsPlatformService.saveGeneralNotifications(vm.notification).then(function(response){
                console.log(response.data);
                toastr.success('Notification was saved')
            }).catch(function(err){
                toastr.error(err.data.message)
            }).finally(function(){
                $uibModalInstance.close();
            })
        }

        function hideModal(){
            $uibModalInstance.close();
        } 

        function removeLinkOptions(){
            CKEDITOR.on('dialogDefinition', function (ev) {
                var dialogName = ev.data.name
                var dialogDefinition = ev.data.definition
                if(dialogName === 'link'){
                    var infoTab = dialogDefinition.getContents( 'info' );
                    dialogDefinition.getContents('info').get('linkType').hidden = true;
                    dialogDefinition.getContents('info').get('protocol').hidden = true;
                    
                    console.log('PROTOCOL')
                    console.log(dialogDefinition.getContents('info').get('protocol'))
                }
            })
        }

        activate();
    }

})();